import { Editor, type Element, createEditor } from 'slate';
import { MigrateToV2 } from '../../migration';
import { decodeFragment } from '../../util/fragment';
import Serializer, { type DeserializeArguments } from './Serializer';
import type { DocumentValue } from '../../types/aha-editor';
import { isHTMLElementNode } from '../../serialization/helpers/serializerHelpers';

const elementAllowList = [
  'embedded-whiteboard',
  'pill',
  'infoBlock',
  'noteBlock',
  'warningBlock',
  'tipBlock',
  'checklist',
  'user-reference',
  'aha-reference',
  'embedded-report',
];

class SerializerFragment extends Serializer {
  static fragmentContainsAllowlistedElements(fragment: DocumentValue): boolean {
    const fragmentEditor = createEditor();
    fragmentEditor.children = fragment.children;
    const allowListedElementsGenerator = Editor.nodes(fragmentEditor, {
      at: {
        anchor: Editor.start(fragmentEditor, []),
        focus: Editor.end(fragmentEditor, []),
      },
      match: (e: Element) => elementAllowList.includes(e.type),
    });

    const allowListElement = allowListedElementsGenerator.next();
    return !!allowListElement.value;
  }

  static deserialize({ el }: DeserializeArguments) {
    if (!isHTMLElementNode(el)) return null;
    if (!el.dataset.slateFragment) return null;

    const fragment = decodeFragment(el.dataset.slateFragment);

    const node = MigrateToV2(
      // Quack like a v1 document value
      {
        object: 'value',
        document: {
          object: 'document',
          nodes: [],
          ...fragment,
        },
      }
    );
    if (!this.fragmentContainsAllowlistedElements(node)) return null;

    return node.children;
  }
}
export default SerializerFragment;
